export default "__VITE_ASSET__CcOuNB2p__"